import React from "react";
import Helmet from "react-helmet";

interface Props {
  pagePath?: string;
  metaInfo: {
    metaTitle?: string;
    metaDescription?: string;
    metaKeywords?: string;
    metaCanonical?: string;
    openImage?: {
      asset: {
        url: string;
      };
    };
    twitterImage?: {
      asset: {
        url: string;
      };
    };
    twitterTitle?: string;
    openTitle?: string;
    openGraphDescription?: string;
    twitterDescription?: string;
  };
  globalMeta: {
    metaTitle?: string;
    metaDescription?: string;
    metaCanonical?: string;
    metaKeywords?: string;
    favicon?: {
      url: string;
    };
    openImage?: {
      asset: {
        url: string;
      };
    };
    twitterImage?: {
      asset: {
        url: string;
      };
    };
    twitterTitle?: string;
    openTitle?: string;
    openGraphDescription?: string;
    twitterDescription?: string;
  };
}

const SEO = ({ pagePath, metaInfo, globalMeta }: Props) => {
  const title = metaInfo?.metaTitle
    ? metaInfo?.metaTitle
    : globalMeta?.metaTitle;

  const metaDescription = metaInfo?.metaDescription
    ? metaInfo?.metaDescription
    : globalMeta?.metaDescription;

  const metaKeywords = metaInfo?.metaKeywords
    ? metaInfo?.metaKeywords
    : globalMeta?.metaKeywords;

  const twitterImage = metaInfo?.openImage
    ? metaInfo?.twitterImage
    : globalMeta?.openImage?.asset?.url;

  const ogImage = metaInfo?.openImage
    ? metaInfo?.ogImage
    : globalMeta?.openImage?.asset?.url;

  const openTitle = metaInfo?.openTitle
    ? metaInfo?.openTitle
    : globalMeta?.metaDescription;

  const openGraphDescription = metaInfo?.openGraphDescription
    ? metaInfo?.openGraphDescription
    : globalMeta?.openGraphDescription;

  const twitterTitle = metaInfo?.twitterTitle
    ? metaInfo?.twitterTitle
    : globalMeta?.openTitle;

  const twitterDescription = metaInfo?.twitterDescription
    ? metaInfo?.twitterDescription
    : globalMeta?.metaDescription;


  let selfReference = `${process.env.GATSBY_URL}${pagePath}`;

  return (
    <Helmet title={title}>
      <html lang="en" />
      {/* 
        TODO: Check which meta is actually needed.
      */}
      <meta http-equiv="Accept-CH" content="DPR, Width, Viewport-Width" />
      <meta property="og:locale" content="en_US" />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta
        property="og:url"
        content={`${process.env.GATSBY_URL}/${pagePath ? pagePath : ""}`}
      />
      <meta property="og:image" content={ogImage} />
      <meta property="og:title" content={`${openTitle}`} />
      <meta property="og:type" content="website"></meta>
      <meta property="og:site_name" content="Groove Pillow" />
      <meta property="og:description" content={openGraphDescription} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${twitterTitle}`} />
      <link rel="canonical" href={selfReference} />
      <link rel="alternate" href={`https://www.groovepillows.co.uk${pagePath}`} hreflang="en-gb" />
      <link rel="alternate" href={`https://www.groovepillows.com${pagePath}`} hreflang="en-us" />
      <link rel="alternate" href={`https://www.groovepillows.co.uk${pagePath}`} hreflang="x-default" />
      <meta name="twitter:image" content={twitterImage} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta property="twitter:domain" content={process.env.GATSBY_URL}></meta>
      <meta property="twitter:url" content={process.env.GATSBY_URL}></meta>
      <meta
        name="twitter:url"
        content={`${process.env.GATSBY_URL}/${pagePath ? pagePath : ""}`}
      />
      {globalMeta?.favicon && (
        <link
          rel="shortcut icon"
          type="image/png"
          href={globalMeta?.favicon.url}
          as="image"
          crossOrigin
        />
      )}
      {/*  Start VWO Async SmartCode */}
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type='text/javascript' id='vwoCode'>
        {`window._vwo_code || (function() {
          var account_id=741836,
          version=2.0,
          settings_tolerance=2000,
          hide_element='body',
          hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
          /* DO NOT EDIT BELOW THIS LINE */
          f=false,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?window.sessionStorage:window.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!window.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();window._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',o=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));o.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};window._vwo_code=code;code.init();})(); `}
      </script>
      {/* End VWO Async SmartCode */}
    </Helmet>
  );
};

export default SEO;
